import CurrencyLogo from 'components/CurrencyLogo'
import Tag from 'components/Tag'
import React, { useState } from 'react'

import { EntriesStyled, PoolCardStyled } from './styled'
import { SkeletonText } from 'components/Skeleton'
import { useToken } from 'hooks/Tokens'
import { STHYPE_ADDRESS } from '@hyperswap/addresses'
import { Currency } from '@uniswap/sdk-core'
import { ReactComponent as ThunderHeadLogoWhite } from '../../../assets/thunderhead-logo-full-white.svg'
import { ReactComponent as ImperatorLogoWhite } from '../../../assets/imperator-logo-full-white.svg'
import { formatUnits } from 'ethers/lib/utils'
import axios from 'axios'
import { API_GRAPHQL_STHYPE } from 'constants/links'
import { roundToDecimalPlace } from 'utils/data'
import { EARN_STHYPE_IS_DISABLED } from 'constants/config'

const IS_DISABLED = EARN_STHYPE_IS_DISABLED

const STHYPEPoolCard: React.FC = () => {
  const stHYPEToken = useToken(STHYPE_ADDRESS)
  const [data, setData] = useState<any>({
    apr: null,
    totalHYPEStaked: null,
  })
  const [loading, setLoading] = useState<boolean>(true)

  React.useEffect(() => {
    async function fetchData() {
      try {
        // Axios POST request to the GraphQL endpoint
        const response = await axios.post(API_GRAPHQL_STHYPE, {
          query: `
          query MyQuery {
           
            mintValuePerCommunity {
              communityCode
              totalValue
            }
            totalCurrentlyStaked
            uniqueMintsFrom
          }
        `,
          variables: null,
          operationName: 'MyQuery',
        })

        let totalSTHYPE = 0
        const mintValuePerCommunity = response?.data?.data?.mintValuePerCommunity
        mintValuePerCommunity?.forEach((community: any) => {
          totalSTHYPE = totalSTHYPE + parseFloat(formatUnits(community.totalValue, 18))
        })

        // Extract the APR value from the GraphQL response
        const apr = response?.data?.data?.statsAtRebases?.apr
        const totalHYPEStaked = response?.data?.data?.totalCurrentlyStaked

        // Update the state with both results
        setData({
          apr: apr,
          totalHYPEStaked: totalHYPEStaked && formatUnits(totalHYPEStaked, 18),
        })

        setLoading(false)
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }

    if (loading) {
      fetchData()
    }
  }, [loading])

  return (
    <PoolCardStyled role="button" to={`/stake/stHYPE`} disabled={IS_DISABLED}>
      <div className="poolCard__tag">
        {IS_DISABLED ? <Tag variant={1}>Inactive</Tag> : <Tag variant={2}>Active</Tag>}
      </div>

      <div className="poolCard__header">
        <CurrencyLogo currency={stHYPEToken as Currency} size={'42px'} />
        <h2>Earn stHYPE</h2>
      </div>
      <div className="poolCard__subheader">
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <span>Powered by</span> <ThunderHeadLogoWhite />
          <span>Thunderhead &</span>
          <ImperatorLogoWhite />
          <span>Imperator</span>
        </div>
      </div>
      <EntriesStyled>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>APR</span>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>TVL</span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          {loading || !data?.apr || IS_DISABLED ? (
            <SkeletonText width="50%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.apr, '3')}%`
          )}
        </span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          {loading || !data?.totalHYPEStaked || IS_DISABLED ? (
            <SkeletonText width="80%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.totalHYPEStaked, '3')} HYPE`
          )}
        </span>
      </EntriesStyled>
    </PoolCardStyled>
  )
}
export default STHYPEPoolCard
